import React from 'react';
import { ThermometerSnowflake, Phone, Mail, MapPin, Facebook, Instagram } from 'lucide-react';
export function Footer() {
  return <footer className="bg-muted/50 border-t" data-id="element-136">
      <div className="container mx-auto px-4 py-12 md:px-6 lg:py-16" data-id="element-137">
        <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-4" data-id="element-138">
          {/* Company Info */}
          <div className="space-y-4" data-id="element-139">
            <div className="flex items-center gap-2" data-id="element-140">
              <img src="https://cdn.magicpatterns.com/uploads/1Stki6WQT8fun4qYjVmCAY/sunflow-primary-logo-full-color-rgb-900px-w-72ppi.png" alt="Sunflow Heated Driveways" className="h-12 w-auto" data-id="element-141" />
            </div>
            <p className="text-sm text-muted-foreground" data-id="element-142">
              Professional heated driveway installation and outdoor heating
              systems across Ontario. Keep your home safe and accessible all
              winter long.
            </p>
            <div className="flex gap-4" data-id="element-143">
              <a href="https://www.facebook.com/hellosunflow" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-primary" data-id="element-144">
                <Facebook className="h-5 w-5" data-id="element-145" />
                <span className="sr-only" data-id="element-146">Facebook</span>
              </a>
              <a href="https://www.instagram.com/sunflowsolarandexteriors/" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-primary" data-id="element-147">
                <Instagram className="h-5 w-5" data-id="element-148" />
                <span className="sr-only" data-id="element-149">Instagram</span>
              </a>
            </div>
          </div>

          {/* Services */}
          <div data-id="element-150">
            <h3 className="mb-4 text-sm font-semibold uppercase tracking-wider" data-id="element-151">
              Services
            </h3>
            <ul className="space-y-3 text-sm text-muted-foreground" data-id="element-152">
              <li data-id="element-153">Heated Driveways</li>
              <li data-id="element-154">Heated Walkways</li>
              <li data-id="element-155">Patio Heating</li>
              <li data-id="element-156">Snow Melting Systems</li>
              <li data-id="element-157">System Maintenance</li>
            </ul>
          </div>

          {/* Service Areas */}
          <div data-id="element-158">
            <h3 className="mb-4 text-sm font-semibold uppercase tracking-wider" data-id="element-159">
              Service Areas
            </h3>
            <ul className="space-y-3 text-sm text-muted-foreground" data-id="element-160">
              <li data-id="element-161">Toronto & GTA</li>
              <li data-id="element-162">Ottawa</li>
              <li data-id="element-163">Hamilton</li>
              <li data-id="element-164">London</li>
              <li data-id="element-165">Barrie & Simcoe</li>
              <li data-id="element-166">All of Ontario</li>
            </ul>
          </div>

          {/* Contact */}
          <div data-id="element-167">
            <h3 className="mb-4 text-sm font-semibold uppercase tracking-wider" data-id="element-168">
              Contact Us
            </h3>
            <ul className="space-y-3 text-sm text-muted-foreground" data-id="element-169">
              <li className="flex items-start gap-2" data-id="element-170">
                <MapPin className="h-5 w-5 shrink-0 text-primary" data-id="element-171" />
                <span data-id="element-172">30 Quarry Ridge Rd, Barrie, ON L4M 7G1</span>
              </li>
              <li className="flex items-center gap-2" data-id="element-173">
                <Phone className="h-5 w-5 shrink-0 text-primary" data-id="element-174" />
                <a href="tel:647-706-9908" className="hover:text-primary" data-id="element-175">
                  (647) 706-9908
                </a>
              </li>
              <li className="flex items-center gap-2" data-id="element-176">
                <Mail className="h-5 w-5 shrink-0 text-primary" data-id="element-177" />
                <a href="mailto:sales@sunflowheateddrivesways.com" className="hover:text-primary" data-id="element-178">
                  sales@sunflowheateddrivesways.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 border-t pt-8 text-center text-sm text-muted-foreground" data-id="element-179">
          <p data-id="element-180">
            &copy; {new Date().getFullYear()} Sunflow Heated Driveways. All
            rights reserved.
          </p>
        </div>
      </div>
    </footer>;
}